import { createBrowserRouter, RouterProvider } from 'react-router-dom'
import { AppRoutes } from './AppRoutes'
import { createRouter } from './router'

const router = createBrowserRouter([{ path: '*', element: <AppRoutes /> }])

createRouter(router)

export function AppRouter(): React.ReactNode {
  return <RouterProvider router={router} />
}
